module.exports = __webpack_public_path__ + "static/media/44.cd66f1ee.JPG";